import React from "react";
import WorkspaceBox from "@icoach/documents/membership/quit/components/WorkspaceBox";
import MembershipDocumentDialogBox from "@icoach/documents/membership/dialog/MembershipDocumentDialogBox";
import { TermContent } from "@icoach/documents/components";
import terms from "@icoach/documents/membership/quit/versionBefore104/terms";
import { Card } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components";
import { formatCurrencyFn } from "@util/utils";
import { displayDateText } from "@util/moment";
import MembershipQuitForm from "@icoach/documents/membership/quit/versionBefore104/MembershipQuitForm";
import FocusModeToggle from "@icoach/components/FocusModeToggle";

const contractInfo = [
	{
		key: "paymentTypeText",
		text: "付款方式",
		formatter: value => value,
		grid: 4,
	},
	{
		key: "monthlyFee",
		text: "月費",
		formatter: value => formatCurrencyFn(value),
		grid: 4,
	},
	{
		key: "joinFee",
		text: "入會費",
		formatter: value => formatCurrencyFn(value),
		grid: 4,
	},
	{
		key: "membershipTermText",
		text: "合約長度",
		formatter: value => value,
		grid: 4,
	},
	{
		key: "membershipPeriod",
		text: "會籍期間",
		formatter: (_, data) => displayDateText(data.startDate, data.endDate),
		grid: 8,
	},
];

const MembershipQuitContract = ({ sourceData, peopleType, contractID, referenceID, isReadOnly }) => {
	const { membership } = sourceData || {};
	const contractInfoWithData = { ...membership, joinFee: sourceData?.joinFee };
	const dialogRef = React.useRef(null);
	const focusModeRef = React.useRef(null);
	
	return (
		<>
			<FocusModeToggle ref={focusModeRef} showToggleFocusModeButton={!isReadOnly}>
				<TermContent sourceData={terms[sourceData?.contractVersion].data || []} className="mb-4" title="會員權終止條款" subheader="依教育部體育署健身中心定型化契約" />
				<Card className="mb-3">
					<Card.CardHeader title="合約方案" className="bg-light text-center" />
					<Card.CardContent className="px-4 py-5">
						<Grid container spacing={2}>
							{contractInfo.map(({ key, text, formatter, grid }) => (
								<Grid item xs={grid} key={key}>
									<ReadTextField label={text}>{formatter(contractInfoWithData?.[key], contractInfoWithData)}</ReadTextField>
								</Grid>
							))}
						</Grid>
					</Card.CardContent>
				</Card>
				<MembershipQuitForm
					sourceData={sourceData}
					peopleType={peopleType}
					contractID={contractID}
					referenceID={referenceID}
					isReadOnly={isReadOnly}
					dialogRef={dialogRef}
					focusModeRef={focusModeRef}
				/>
			</FocusModeToggle>
			{sourceData?.membershipID && sourceData?.memberID ? (
				<WorkspaceBox
					openMembershipRecordDialog={() =>
						dialogRef.current?.openMembershipRecordDialog({
							memberID: sourceData?.memberID,
							membershipID: sourceData?.membershipID,
						})
					}
					openMembershipBillingRecordDialog={() =>
						dialogRef.current?.openMembershipBillingRecordDialog({
							memberID: sourceData?.memberID,
							membershipID: sourceData?.membershipID,
						})
					}
				/>
			) : null}
			<MembershipDocumentDialogBox ref={dialogRef} />
		</>
	);
};

export default MembershipQuitContract;
